import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import * as tokenStatusStyles from './TokenStatus.module.css';

import { TOKEN } from 'utils/Constants.js';
import CmsContentList from 'components/data/CmsContentList.js';
import CmsContentRenderer from 'components/data/CmsContentRenderer.js';

const cms = {
	active: "miscText.cardinfo-status-active",
	inactive: "miscText.cardinfo-status-inactive",
	closed: "miscText.cardinfo-status-closed",
	suspended: "miscText.cardinfo-status-suspended",
	terminated: "miscText.cardinfo-status-terminated",

	reasonPending: "miscText.cardinfo-status-reason-pending",
	reasonWriteoff: "miscText.cardinfo-status-reason-writeoff",
	reasonLost: "miscText.cardinfo-status-reason-lost",
	reasonFraud: "miscText.cardinfo-status-reason-fraud",
	reasonInactive: "miscText.cardinfo-status-reason-inactive",
	reasonFrozen: "miscText.cardinfo-status-reason-frozen",
	reasonClosing: "miscText.cardinfo-status-reason-closing",
	reasonNegative: "miscText.cardinfo-status-reason-negative",
	reasonDefecive: "miscText.cardinfo-status-reason-defecive",
	reasonUpgraded: "miscText.cardinfo-status-reason-upgraded",
	reasonExpired: "miscText.cardinfo-status-reason-expired",
	reasonClosed: "miscText.cardinfo-status-reason-closed",
};

export const applyCardStyles = (
	statusDescription,
	isMobileFareCardParked = false,
	cardHasActionableDebt,
	overrideClass,
) => {
	const {
		active,
		suspended,
		statusText,
		inactive,
	} = tokenStatusStyles;

	const baseStyle = statusText;
	let statusStyle = active;

	switch (statusDescription) {
		case TOKEN.DESCRIPTION.Active:
			statusStyle = isMobileFareCardParked ? inactive : active;
			break;
		case TOKEN.DESCRIPTION.Inactive:
		case TOKEN.DESCRIPTION.PendingActivation:
			statusStyle = inactive;
			break;
		default:
			statusStyle = suspended;
			break;
	}
	// Tokens with debt are returned from api as 'suspended' but we render them as would an "active" card.
	if (cardHasActionableDebt) {
		return cx(baseStyle, active, overrideClass);
	}

	return cx(
		baseStyle,
		statusStyle,
		overrideClass
	);
};

{/*
	updated statusDescription field to use statusReasonCodeDesc based on John
	as of 10/18/2021 https://reflexions.slack.com/archives/CCF68M49M/p1634563407428200

	if statusReasonCode is negative we should not show the status.
	https://reflexions.slack.com/archives/CCF68M49M/p1769128569326999
*/}
const getStatusReasonCodeDescJsx = (statusDescription, statusReasonCode = null, statusReasonCodeDesc) => {

	if (statusDescription === TOKEN.DESCRIPTION.Active || statusReasonCode !== null && statusReasonCode < 0) {
		return <></>;
	}

	return <div className={tokenStatusStyles.reasonDescription}>{statusReasonCodeDesc}</div>;
};


export const TokenStatus = ({
	frontendStatus,
	statusDescription,
	statusReasonCode = null,
	statusReasonCodeDesc,
	cardHasActionableDebt = false,
	elementType: ElementType = "div",
	overrideClass = null,
	isMobileFareCardParked = false,
}) => {

	return (
		<CmsContentList list={Object.values(cms)}>{() => (
			<ElementType className={applyCardStyles(statusDescription, isMobileFareCardParked, cardHasActionableDebt, overrideClass)}>
				{/*
					based on the ticket https://reflexions.atlassian.net/browse/MBTA-966
					we revert cms translations to render BO data
					<div>{cmsContent[ getTokenStatusTranslationKey(frontendStatus, cardHasActionableDebt) ] || frontendStatus}</div>
					<div>{statusDescription !== TOKEN.DESCRIPTION.Active ? cmsContent[ getTokenStatusDescriptionTranslationKey(statusReasonCodeDesc) ] : null}</div>
				*/}
				{isMobileFareCardParked
					? <CmsContentRenderer.Span
						contentKey={cms.inactive}
						fallbackValue='Inactive'
					/>
					: <div>{frontendStatus ? frontendStatus : null}</div>
				}

				{getStatusReasonCodeDescJsx(statusDescription, statusReasonCode, statusReasonCodeDesc)}
			</ElementType>
		)}</CmsContentList>
	);
};

TokenStatus.propTypes = {
	frontendStatus: PropTypes.string.isRequired,
	cardHasActionableDebt: PropTypes.bool,
};

export default TokenStatus;
